import { render, staticRenderFns } from "./WorkAuthorizationDialog.vue?vue&type=template&id=0266d2d0&scoped=true&"
import script from "./WorkAuthorizationDialog.vue?vue&type=script&lang=js&"
export * from "./WorkAuthorizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./WorkAuthorizationDialog.vue?vue&type=style&index=0&id=0266d2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266d2d0",
  null
  
)

export default component.exports